import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { useAuth } from '@/contexts/AuthContext';
import { Link } from 'react-router';

export const HomePage = () => {
  const { isAuthenticated, login } = useAuth();

  return (
    <div className='min-h-screen bg-gradient-to-b from-cyan-50 to-white'>
      <div className='container mx-auto px-4 py-12'>
        {/* Hero Section */}
        <div className='text-center mb-16'>
          <h1 className='text-4xl md:text-6xl font-bold text-cyan-700 mb-6'>Willkommen bei SW! Gutscheinen</h1>
          <p className='text-xl text-gray-600 mb-8 max-w-2xl mx-auto'>
            Entdecken Sie exklusive Gutscheine und Angebote von den Stadtwerken Düren. Sparen Sie bei lokalen Geschäften
            und Dienstleistungen.
          </p>
          {!isAuthenticated ? (
            <div className='space-x-4'>
              <Button onClick={login} size='lg' className='bg-cyan-600 hover:bg-cyan-700'>
                Jetzt anmelden
              </Button>
              <Button asChild variant='outline' size='lg'>
                <Link to='/so-funktioniert-es'>So funktioniert's</Link>
              </Button>
            </div>
          ) : (
            <Button asChild size='lg' className='bg-cyan-600 hover:bg-cyan-700'>
              <Link to='/coupons'>Gutscheine entdecken</Link>
            </Button>
          )}
        </div>

        {/* Features Section */}
        <div className='grid md:grid-cols-3 gap-8 mb-16'>
          <Card>
            <CardHeader>
              <CardTitle className='text-cyan-700'>🎫 Exklusive Angebote</CardTitle>
              <CardDescription>Entdecken Sie einzigartige Gutscheine von lokalen Partnern</CardDescription>
            </CardHeader>
            <CardContent>
              <p className='text-gray-600'>
                Profitieren Sie von besonderen Rabatten und Angeboten, die nur für SW! Kunden verfügbar sind.
              </p>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle className='text-cyan-700'>💚 Nachhaltig sparen</CardTitle>
              <CardDescription>Unterstützen Sie lokale Unternehmen und die Region</CardDescription>
            </CardHeader>
            <CardContent>
              <p className='text-gray-600'>
                Mit jedem eingelösten Gutschein stärken Sie die lokale Wirtschaft und tragen zur Nachhaltigkeit bei.
              </p>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle className='text-cyan-700'>📱 Einfach digital</CardTitle>
              <CardDescription>Alle Gutscheine digital verwalten und einlösen</CardDescription>
            </CardHeader>
            <CardContent>
              <p className='text-gray-600'>
                Keine physischen Gutscheine mehr - alles läuft bequem über Ihr digitales Gutschein-Portemonnaie.
              </p>
            </CardContent>
          </Card>
        </div>

        {/* CTA Section */}
        {!isAuthenticated && (
          <div className='text-center bg-cyan-600 text-white p-8 rounded-lg'>
            <h2 className='text-2xl font-bold mb-4'>Starten Sie noch heute mit dem Sparen!</h2>
            <p className='mb-6'>Melden Sie sich kostenlos an und erhalten Sie Zugang zu exklusiven Gutscheinen.</p>
            <Button onClick={login} variant='secondary' size='lg'>
              Kostenlos registrieren
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};
